<template>
  <div class="columns">
    <div class="column col-8 col-sm-12 col-offset-2 txt--center">
      <h1 class="team__member-headline">
        {{ $t("team.melanie-dubin-beier.name") }}
      </h1>
      <p>{{ $t("team.melanie-dubin-beier.position") }}</p>
    </div>
    <div class="column col-10 col-sm-12 col-offset-1 txt--center">
      <div v-html="$t('team.melanie-dubin-beier.intro')"></div>
    </div>
    <div class="columns col-12">
      <div class="columns columns--quote">
        <div class="column col-5 col-md-12">
          <img
            class="img-responsive profile-photo"
            src="../../../assets/images/team/melanie-dubin-beier.jpg"
          />
        </div>
        <div class="column col-7 col-md-12">
          <blockquote class="quote">
            {{ $t("team.melanie-dubin-beier.quote") }}
          </blockquote>
          <a
            :href="$t('team.melanie-dubin-beier.contact_data')[0].link"
            class="button button--arrow-left quote__link"
            target="_blank"
            >{{ $t("team.melanie-dubin-beier.contact_data")[0].label }}</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DubinBeier",
};
</script>
